import { render, staticRenderFns } from "./HeathMode.vue?vue&type=template&id=1837a636&scoped=true"
import script from "./HeathMode.vue?vue&type=script&lang=js"
export * from "./HeathMode.vue?vue&type=script&lang=js"
import style0 from "./HeathMode.vue?vue&type=style&index=0&id=1837a636&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1837a636",
  null
  
)

export default component.exports